import PrimeAttrSelect from "../../../components/layout/Workspace/selects/PrimeAttrSelect";
import AccentColors from "../../../features/DIYPersonalization/AccentColors";

let initialState = {
  togglePersonalisation: false, // update this state to re-render highcharts
  themeName: "",
  themeId: null,
  themeDescription: "",
  openedColorPickerId: null,
  isPredefined: null,
  isPersonalizationPreviewOpen: false,
  PreviewScreenId: null,
  savedAs: "Theme",
  loader: false,
  selectedConfigureComponent: "Header",
  brandUploadLoader: false,
  brandConfig: {
    logoUrl: null,
    position: null,
  },
  CommandCenterLayout: "B0F0",
  sameConfigForBannerAndFooter: false,
  CommandCenterScreenBanner: {
    background: null,
    title: null,
    subtitle: null,
    textPosition: null,
    DraggedComponentPosition: {
      // positioning for logo and text boxes in banner
      0: {
        x: 0,
        y: 0,
      },
      1: {
        x: 0,
        y: 0,
      },
      2: {
        x: 0,
        y: 0,
      },
    },
    textColor: null,
    fontFamily: null,
    fontSize: null,
    fontWeight: null,
  },
  CommandCenterScreenFooter: {
    subtitle: null,
    textPosition: null,
    textColor: null,
  },
  themeList: null,
  paletteList: [
    {
      name: "Soft and serene",
      isSelected: false,
      PrimaryTextColor: "#4A4A4A",
      SecondaryTextColor: "#7D7D7D",
      ScreenBackgroundColor: "#F1F8E9",
      WidgetHeaderColor: "#A5D6A7",
      WidgetBackgroundColor: "#81D4FA",
      AccentColors: ["#FFB74D", "#FF80AB", "#C5E1A5", "#F48FB1"],
    },
    {
      name: "Warm and Cozy",
      isSelected: false,
      PrimaryTextColor: "#3E3E3E",
      SecondaryTextColor: "#9E9E9E",
      ScreenBackgroundColor: "#FFF3E0",
      WidgetHeaderColor: "#FFCC80",
      WidgetBackgroundColor: "#FFB74D",
      AccentColors: ["#81D4FA", "#C5E1A5", "#FFEB3B", "#FF8A65"],
    },
    {
      name: "Cool and Refreshing",
      isSelected: false,
      PrimaryTextColor: "#4A4A4A",
      SecondaryTextColor: "#9E9E9E",
      ScreenBackgroundColor: "#E1F5FE",
      WidgetHeaderColor: "#80DEEA",
      WidgetBackgroundColor: "#26C6DA",
      AccentColors: ["#FF4081", "#81C784", "#FFEB3B", "#64B5F6"],
    },
  ],
  logosJson: {
    // bannerImage: null,
    brandLogo: null,
  },
};

const PersonalizationSetting = (state = initialState, action) => {
  switch (action.type) {
    case "TOGGLE_PERSONALISATION":
      return {
        ...state,
        togglePersonalisation: action?.value,
      };
    case "SET_SAME_STYLE":
      return {
        ...state,
        sameConfigForBannerAndFooter: action?.value,
      };
    case "SET_SELECTED_CONFIG_COMPONENT":
      return {
        ...state,
        selectedConfigureComponent: action?.value,
      };
    case "SET_SELECTED_PALETTE": {
      return {
        ...state,
        paletteList: state.paletteList.map(
          (palette, index) =>
            index === action?.index
              ? {
                  ...palette,
                  isSelected: action.value,
                }
              : {
                  ...palette,
                  isSelected: false,
                } // Keep other palettes unchanged
        ),
      };
    }
    case "SET_CUSTOM_PALETTE_INFO": {
      return {
        ...state,
        paletteList: state.paletteList.map(
          (palette, index) =>
            index == action?.payload.index
              ? {
                  ...palette,
                  [action.payload.componentKey]: action.payload.value,
                }
              : {
                  ...palette,
                } // Keep other palettes unchanged
        ),
      };
    }
    case "SET_BANNER_FONT_WEIGHT":
      return {
        ...state,
        CommandCenterScreenBanner: {
          ...state?.CommandCenterScreenBanner,
          fontWeight: action?.value,
        },
      };
    case "SET_BANNER_FONT_SIZE":
      return {
        ...state,
        CommandCenterScreenBanner: {
          ...state?.CommandCenterScreenBanner,
          fontSize: action.value,
        },
      };
    case "SET_BANNER_FONT_FAMILY":
      return {
        ...state,
        CommandCenterScreenBanner: {
          ...state?.CommandCenterScreenBanner,
          fontFamily: action.value,
        },
      };
    case "SET_DRAGGED_COMPONENT_POSITIONS":
      return {
        ...state,
        CommandCenterScreenBanner: {
          ...state?.CommandCenterScreenBanner,
          DraggedComponentPosition: action.value,
        },
      };
    case "SET_BANNER_TEXTBOX_POSITION":
      return {
        ...state,
        CommandCenterScreenBanner: {
          ...state?.CommandCenterScreenBanner,
          textPosition: action.value,
        },
      };
    case "SET_FOOTER_TEXTBOX_POSITION":
      return {
        ...state,
        CommandCenterScreenFooter: {
          ...state?.CommandCenterScreenFooter,
          textPosition: action.value,
        },
      };
    case "SET_BANNER_TITLE":
      return {
        ...state,
        CommandCenterScreenBanner: {
          ...state?.CommandCenterScreenBanner,
          title: action.value,
        },
      };
    case "SET_BANNER_SUBTITLE":
      return {
        ...state,
        CommandCenterScreenBanner: {
          ...state?.CommandCenterScreenBanner,
          subtitle: action.value,
        },
      };
    case "SET_FOOTER_SUBTITLE":
      return {
        ...state,
        CommandCenterScreenFooter: {
          ...state?.CommandCenterScreenFooter,
          subtitle: action.value,
        },
      };
    case "RESET_PERSONALIZATION_SETTINGS":
      return {
        ...initialState,
      };
    case "SET_PREVIEW_SCREEN_ID":
      return {
        ...state,
        PreviewScreenId: action?.value,
      };
    case "SET_IS_PERSONALIZATION_PREVIEW_OPEN":
      return {
        ...state,
        isPersonalizationPreviewOpen: action?.value,
      };
    case "SET_HEADER_AND_FOOTER_LAYOUT_CONFIG":
      return {
        ...state,
        CommandCenterLayout: action?.value,
      };
    case "SET_COMPONENT_BACKGROUND":
      return {
        ...state,
        [action.payload.componentKey]: {
          ...state[action.payload.componentKey],
          background: action.payload.backgroundValue,
        },
      };
    case "SET_BANNER_TEXT_COLOR":
      return {
        ...state,
        [action.payload.componentKey]: {
          ...state[action?.payload?.componentKey],
          textColor: action.payload.value,
        },
      };
    case "SET_BRAND_UPLOAD_LOADER":
      return {
        ...state,
        brandUploadLoader: action?.value,
      };

    case "SET_BRAND_CONFIG":
      return {
        ...state,
        brandConfig: action?.value,
      };
    case "SET_LOGO_URL_IN_BRAND_CONFIG":
      return {
        ...state,
        brandConfig: {
          ...state?.brandConfig,
          logoUrl: action?.url,
        },
      };
    case "SET_LOGO_IMAGE_URL_IN_LOGOS_JSON":
      return {
        ...state,
        logosJson: {
          ...state?.logosJson,
          brandLogo: action?.url,
        },
      };
    case "SET_BANNER_IMAGE_URL_IN_LOGOS_JSON":
      return {
        ...state,
        logosJson: {
          ...state?.logosJson,
          bannerImage: action?.url,
        },
        CommandCenterScreenBanner: {
          ...state?.CommandCenterScreenBanner,
          background: action?.url,
        },
      };
    case "SET_LOGO_POSITION_IN_BRAND_CONFIG":
      return {
        ...state,
        brandConfig: {
          ...state?.brandConfig,
          position: action?.position,
        },
      };
    case "SET_LOGO_STYLE_IN_LOCOBUZZ_CONFIG":
      return {
        ...state,
        locobuzzLogoConfig: {
          ...state?.locobuzzLogoConfig,
          style: action?.style,
        },
      };
    case "SET_LOGO_POSITION_IN_LOCOBUZZ_CONFIG":
      return {
        ...state,
        locobuzzLogoConfig: {
          ...state?.locobuzzLogoConfig,
          position: action?.position,
        },
      };

    case "SET_AVAILABLE_THEMES_DETAILS":
      let isSelectedThemePresentInUpdatedList = action.themeList?.find(
        (theme) => theme.theme_id === state.themeId
      );
      let firstTheme = action.themeList?.[0];
      if (
        !isSelectedThemePresentInUpdatedList &&
        action.themeList?.length > 0
      ) {
        return {
          ...state,
          themeName: firstTheme?.theme_name,
          themeId: firstTheme?.theme_id,
          themeDescription: firstTheme?.theme_description,
          isPredefined: firstTheme?.is_predefined,
          savedAs: firstTheme?.saved_as,
          brandConfig: {
            ...firstTheme?.theme_json?.brandConfig,
          },
          CommandCenterLayout: firstTheme?.theme_json?.CommandCenterLayout
            ? firstTheme?.theme_json?.CommandCenterLayout
            : null,
          CommandCenterScreenBanner: {
            ...firstTheme?.theme_json?.CommandCenterScreenBanner,
          },
          CommandCenterScreenFooter: {
            ...firstTheme?.theme_json?.CommandCenterScreenFooter,
          },
          paletteList: [...firstTheme?.theme_json?.paletteList],
          logosJson: {
            ...firstTheme?.logos_json,
          },
          themeList: action?.themeList,
        };
      } else {
        return {
          ...state,
          themeList: action.themeList,
        };
      }
    case "SEL_SELECTED_THEME_STATE":
      let selectedTheme;

      if (typeof action.payload === "object" && action.payload !== null) {
        selectedTheme = action.payload;
      } else {
        const themeId = action.payload;
        selectedTheme = state?.themeList?.find(
          (theme) => theme?.theme_id == themeId
        );
      }
      if (!selectedTheme) {
        return state;
      }
      return {
        ...state,
        themeName: selectedTheme.theme_name,
        themeId: selectedTheme.theme_id,
        themeDescription: selectedTheme.theme_description,
        isPredefined: selectedTheme.is_predefined,
        savedAs: selectedTheme.saved_as,
        selectedConfigureComponent: null,
        brandUploadLoader: false,
        brandConfig: selectedTheme?.theme_json?.brandConfig,
        CommandCenterLayout: selectedTheme?.theme_json?.CommandCenterLayout,
        CommandCenterScreenBanner:
          selectedTheme.theme_json?.CommandCenterScreenBanner,

        CommandCenterScreenFooter:
          selectedTheme.theme_json?.CommandCenterScreenFooter,

        paletteList:
          selectedTheme?.theme_json?.paletteList || state?.paletteList,
        logosJson: selectedTheme?.logos_json,
        themeList: state.themeList,
      };
    case "RESET_THEME_STATE":
      return {
        ...action.payload,
        themeList: state.themeList,
      };
    case "SET_COLOR_PICKER_ID":
      return {
        ...state,
        openedColorPickerId: action.payload,
      };
    default:
      return state;
  }
};

export default PersonalizationSetting;
